"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPendingActionExpired = isPendingActionExpired;
exports.getSsoRedirectUrl = getSsoRedirectUrl;
exports.redirectToSsoClient = redirectToSsoClient;
exports.getMultiAuthRedirectUrl = getMultiAuthRedirectUrl;
exports.redirectToMultiAuthClient = redirectToMultiAuthClient;
const enums_1 = require("@aurora/shared-types/pages/enums");
const UrlBuilder_1 = __importDefault(require("../urls/UrlHelper/UrlBuilder"));
const UrlHelper_1 = __importDefault(require("../urls/UrlHelper/UrlHelper"));
/**
 * Whether the anonymous user action has expired
 * @param anonymousUserAction The intended anonymous user action
 * @param validTimeLapse Max amount of time since action took place (in minutes)
 */
function isPendingActionExpired(anonymousUserAction, validTimeLapse = 2) {
    // Elapsed time in seconds.
    const elapsedTime = (Date.now() - (anonymousUserAction === null || anonymousUserAction === void 0 ? void 0 : anonymousUserAction.timeStamp)) / 1000;
    // More than "validTimeLapse" minutes since the user intended the action, the action is expired
    return !Number.isNaN(elapsedTime) && elapsedTime > validTimeLapse * 60;
}
/**
 * Returns a build url to Sso client with referer to the path
 * @param communitySsoProperties The community sso properties
 * @param tenant The tenant
 * @param path Path to add as referer
 * @param useRegisterUrl whether to use registration url (default is login)
 */
function getSsoRedirectUrl(communitySsoProperties, tenant, path, useRegisterUrl = false) {
    var _a, _b;
    const { ssoProperties, samlProperties } = communitySsoProperties;
    const refererUrl = UrlHelper_1.default.getFullyQualifiedUrlForPath(tenant, path);
    const destinationUrl = useRegisterUrl
        ? ssoProperties.communitySignUpUrl
        : ssoProperties.communitySignOnUrl;
    const queryStringEnabled = useRegisterUrl
        ? samlProperties.registerQueryStringEnabled
        : samlProperties.loginQueryStringEnabled;
    const queryStringValue = useRegisterUrl
        ? samlProperties.registerQueryStringValue
        : samlProperties.loginQueryStringValue;
    const url = UrlBuilder_1.default.fromUrl(destinationUrl !== null && destinationUrl !== void 0 ? destinationUrl : '').addQuery({
        [(_a = ssoProperties.ssoQsParam) !== null && _a !== void 0 ? _a : enums_1.EndUserQueryParams.REFERER]: UrlHelper_1.default.sanitize(refererUrl)
    });
    if (queryStringEnabled && queryStringValue) {
        // use default in case the query string is invalid
        const queryParam = (_b = UrlBuilder_1.default.fromUrl(queryStringValue).uri.query()) !== null && _b !== void 0 ? _b : {};
        const queryStringEncodeEnabled = useRegisterUrl
            ? samlProperties.registerQueryStringEncodeValueEnabled
            : samlProperties.loginQueryStringEncodeValueEnabled;
        url.addQuery(queryParam, true, queryStringEncodeEnabled !== null && queryStringEncodeEnabled !== void 0 ? queryStringEncodeEnabled : false);
    }
    return url.build();
}
/**
 * Redirects to the sso client
 * @param communitySsoProperties The community sso properties
 * @param tenant the tenant
 * @param refererPath path to add as referer
 * @param useRegisterUrl whether to use registration url (default is login)
 */
function redirectToSsoClient(communitySsoProperties, tenant, refererPath, useRegisterUrl = false) {
    window.location.href = getSsoRedirectUrl(communitySsoProperties, tenant, refererPath, useRegisterUrl);
}
/**
 * Returns a build url to multi-auth client with referer to the path
 * @param authProvider Community auth providers
 * @param tenant the tenant
 * @param refererPath path to add as referer
 * @param referrerQueryParam the query param key to use for the referrer
 */
function getMultiAuthRedirectUrl(authProvider, tenant, refererPath, referrerQueryParam = enums_1.EndUserQueryParams.REFERER) {
    var _a;
    const refererUrl = UrlHelper_1.default.getFullyQualifiedUrlForPath(tenant, refererPath);
    return UrlBuilder_1.default.fromUrl((_a = authProvider.loginURL) !== null && _a !== void 0 ? _a : '')
        .addQuery({
        [referrerQueryParam]: UrlHelper_1.default.sanitize(refererUrl)
    })
        .build();
}
/**
 * Redirects to the multi-auth client
 * @param authProvider Community auth providers
 * @param tenant the tenant
 * @param refererPath path to add as referer
 * @param referrerQueryParam the query param key to use for the referrer
 */
function redirectToMultiAuthClient(authProvider, tenant, refererPath, referrerQueryParam = enums_1.EndUserQueryParams.REFERER) {
    window.location.href = getMultiAuthRedirectUrl(authProvider, tenant, refererPath, referrerQueryParam);
}
//# sourceMappingURL=AnonymousUserActionsHelper.js.map